import React, { useCallback } from "react";
import SafeIcon from "../../../../img/approval_svgs/Safe.svg?react";
import { IconContainer } from "./elements/IconContainer";
import { Text } from "../../../../components/general/Text";
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { FlexContainer } from "../../../../containers/FlexContainer";
import { useAccount } from "wagmi";
import { ApprovalStore } from "../../../../store/approvals/ApprovalsStore";

const metamaskPanelHeight = 120;
const rowPanelHeight = 68;
const enableSpendingsSection = 61;
const headerHeight = 200;
export const ApprovalsSplashScreen: React.FC = () => {
  const { connector } = useAccount();
  const numTokens = ApprovalStore.useState(s => s.tokensByFlow.approve.length);
  const isEnableSpendinngApplicable = ApprovalStore.useState(s => s.requiredSignatures.length > 0);
  const isMetamask = connector?.name === "MetaMask";

  const getTotalHeight = useCallback(() => {
    const metaMaskHeight = isMetamask ? metamaskPanelHeight : 0;
    const enableSpendingsHeight = isEnableSpendinngApplicable ? enableSpendingsSection : 0;
    const gap = 14;
    const rowPanelHeightTotal = (rowPanelHeight + gap) * numTokens;
    const totalHeight = metaMaskHeight + rowPanelHeightTotal + enableSpendingsHeight + headerHeight;
    return totalHeight;
  }, [isEnableSpendinngApplicable, isMetamask, numTokens]);

  return (
    <SplashScreenContainer
      css={css`
        height: ${getTotalHeight()}px;
      `}
    >
      <IconContainer>
        {/*The width of the icon does not correspond to the actual width of the path internally */}
        <SafeIcon width={110} />
      </IconContainer>
      <Text
        shouldScale={false}
        textStyle="Title"
        size="Medium"
        textCss={css`
          text-align: center;
          max-width: 250px;
        `}
      >
        Now securely unlock your tokens for trading...
      </Text>
    </SplashScreenContainer>
  );
};

export const SplashScreenContainer = styled(FlexContainer)`
  flex-direction: column;
  justify-content: center;
  gap: 35px;
  height: 462px;
`;
